// extracted by mini-css-extract-plugin
module.exports = {"help-container":"help_help-container__Qo2r9","heading":"help_heading__PcZDP","faq-container":"help_faq-container__erpbw","spinner":"help_spinner__8f5FE"};